var map = {
	"./+account/account.module": [
		"./src/app/+account/account.module.ts",
		"default~account-account-module~course-course-module~listening-listening-module~my-course-my-course-m~a1b04165",
		"default~account-account-module~course-course-module",
		"account-account-module"
	],
	"./+course/course.module": [
		"./src/app/+course/course.module.ts",
		"default~account-account-module~course-course-module~listening-listening-module~my-course-my-course-m~a1b04165",
		"default~course-course-module~listening-listening-module~my-course-my-course-module~online-test-tests~9d2660cc",
		"default~account-account-module~course-course-module",
		"course-course-module"
	],
	"./+listening/listening.module": [
		"./src/app/+listening/listening.module.ts",
		"default~account-account-module~course-course-module~listening-listening-module~my-course-my-course-m~a1b04165",
		"default~course-course-module~listening-listening-module~my-course-my-course-module~online-test-tests~9d2660cc",
		"default~listening-listening-module~my-course-my-course-module~practice-practice-module~reading-readi~0f99d853",
		"default~listening-listening-module~my-course-my-course-module~reading-reading-module~speaking-speaki~06a585e5",
		"listening-listening-module"
	],
	"./+my-course/my-course.module": [
		"./src/app/+my-course/my-course.module.ts",
		"default~account-account-module~course-course-module~listening-listening-module~my-course-my-course-m~a1b04165",
		"default~course-course-module~listening-listening-module~my-course-my-course-module~online-test-tests~9d2660cc",
		"default~listening-listening-module~my-course-my-course-module~practice-practice-module~reading-readi~0f99d853",
		"default~listening-listening-module~my-course-my-course-module~reading-reading-module~speaking-speaki~06a585e5"
	],
	"./+practice/practice.module": [
		"./src/app/+practice/practice.module.ts",
		"default~account-account-module~course-course-module~listening-listening-module~my-course-my-course-m~a1b04165",
		"default~course-course-module~listening-listening-module~my-course-my-course-module~online-test-tests~9d2660cc",
		"default~listening-listening-module~my-course-my-course-module~practice-practice-module~reading-readi~0f99d853",
		"practice-practice-module"
	],
	"./+reading/reading.module": [
		"./src/app/+reading/reading.module.ts",
		"default~account-account-module~course-course-module~listening-listening-module~my-course-my-course-m~a1b04165",
		"default~course-course-module~listening-listening-module~my-course-my-course-module~online-test-tests~9d2660cc",
		"default~listening-listening-module~my-course-my-course-module~practice-practice-module~reading-readi~0f99d853",
		"default~listening-listening-module~my-course-my-course-module~reading-reading-module~speaking-speaki~06a585e5",
		"reading-reading-module"
	],
	"./+speaking/speaking.module": [
		"./src/app/+speaking/speaking.module.ts",
		"default~account-account-module~course-course-module~listening-listening-module~my-course-my-course-m~a1b04165",
		"default~course-course-module~listening-listening-module~my-course-my-course-module~online-test-tests~9d2660cc",
		"default~listening-listening-module~my-course-my-course-module~practice-practice-module~reading-readi~0f99d853",
		"default~listening-listening-module~my-course-my-course-module~reading-reading-module~speaking-speaki~06a585e5",
		"speaking-speaking-module"
	],
	"./+test01/test.module": [
		"./src/app/+practice/online-test/tests/+test01/test.module.ts",
		"default~account-account-module~course-course-module~listening-listening-module~my-course-my-course-m~a1b04165",
		"default~course-course-module~listening-listening-module~my-course-my-course-module~online-test-tests~9d2660cc",
		"test01-test-module"
	],
	"./+test02/test.module": [
		"./src/app/+practice/online-test/tests/+test02/test.module.ts",
		"default~account-account-module~course-course-module~listening-listening-module~my-course-my-course-m~a1b04165",
		"default~course-course-module~listening-listening-module~my-course-my-course-module~online-test-tests~9d2660cc",
		"test02-test-module"
	],
	"./+test03/test.module": [
		"./src/app/+practice/online-test/tests/+test03/test.module.ts",
		"default~account-account-module~course-course-module~listening-listening-module~my-course-my-course-m~a1b04165",
		"default~course-course-module~listening-listening-module~my-course-my-course-module~online-test-tests~9d2660cc",
		"test03-test-module"
	],
	"./+test04/test.module": [
		"./src/app/+practice/online-test/tests/+test04/test.module.ts",
		"default~account-account-module~course-course-module~listening-listening-module~my-course-my-course-m~a1b04165",
		"default~course-course-module~listening-listening-module~my-course-my-course-module~online-test-tests~9d2660cc",
		"test04-test-module"
	],
	"./+test05/test.module": [
		"./src/app/+practice/online-test/tests/+test05/test.module.ts",
		"default~account-account-module~course-course-module~listening-listening-module~my-course-my-course-m~a1b04165",
		"default~course-course-module~listening-listening-module~my-course-my-course-module~online-test-tests~9d2660cc",
		"test05-test-module"
	],
	"./+test06/test.module": [
		"./src/app/+practice/online-test/tests/+test06/test.module.ts",
		"default~account-account-module~course-course-module~listening-listening-module~my-course-my-course-m~a1b04165",
		"default~course-course-module~listening-listening-module~my-course-my-course-module~online-test-tests~9d2660cc",
		"test06-test-module"
	],
	"./+test07/test.module": [
		"./src/app/+practice/online-test/tests/+test07/test.module.ts",
		"default~account-account-module~course-course-module~listening-listening-module~my-course-my-course-m~a1b04165",
		"default~course-course-module~listening-listening-module~my-course-my-course-module~online-test-tests~9d2660cc",
		"test07-test-module"
	],
	"./+test08/test.module": [
		"./src/app/+practice/online-test/tests/+test08/test.module.ts",
		"default~account-account-module~course-course-module~listening-listening-module~my-course-my-course-m~a1b04165",
		"default~course-course-module~listening-listening-module~my-course-my-course-module~online-test-tests~9d2660cc",
		"test08-test-module"
	],
	"./+test09/test.module": [
		"./src/app/+practice/online-test/tests/+test09/test.module.ts",
		"default~account-account-module~course-course-module~listening-listening-module~my-course-my-course-m~a1b04165",
		"default~course-course-module~listening-listening-module~my-course-my-course-module~online-test-tests~9d2660cc",
		"test09-test-module"
	],
	"./+test10/test.module": [
		"./src/app/+practice/online-test/tests/+test10/test.module.ts",
		"default~account-account-module~course-course-module~listening-listening-module~my-course-my-course-m~a1b04165",
		"default~course-course-module~listening-listening-module~my-course-my-course-module~online-test-tests~9d2660cc",
		"test10-test-module"
	],
	"./+test11/test.module": [
		"./src/app/+practice/online-test/tests/+test11/test.module.ts",
		"default~account-account-module~course-course-module~listening-listening-module~my-course-my-course-m~a1b04165",
		"default~course-course-module~listening-listening-module~my-course-my-course-module~online-test-tests~9d2660cc",
		"test11-test-module"
	],
	"./+test12/test.module": [
		"./src/app/+practice/online-test/tests/+test12/test.module.ts",
		"default~account-account-module~course-course-module~listening-listening-module~my-course-my-course-m~a1b04165",
		"default~course-course-module~listening-listening-module~my-course-my-course-module~online-test-tests~9d2660cc",
		"test12-test-module"
	],
	"./+test13/test.module": [
		"./src/app/+practice/online-test/tests/+test13/test.module.ts",
		"default~account-account-module~course-course-module~listening-listening-module~my-course-my-course-m~a1b04165",
		"default~course-course-module~listening-listening-module~my-course-my-course-module~online-test-tests~9d2660cc",
		"test13-test-module"
	],
	"./+writing/writing.module": [
		"./src/app/+writing/writing.module.ts",
		"default~account-account-module~course-course-module~listening-listening-module~my-course-my-course-m~a1b04165",
		"default~course-course-module~listening-listening-module~my-course-my-course-module~online-test-tests~9d2660cc",
		"default~listening-listening-module~my-course-my-course-module~practice-practice-module~reading-readi~0f99d853",
		"default~listening-listening-module~my-course-my-course-module~reading-reading-module~speaking-speaki~06a585e5",
		"writing-writing-module"
	],
	"./online-test/tests/tests.module": [
		"./src/app/+practice/online-test/tests/tests.module.ts",
		"default~account-account-module~course-course-module~listening-listening-module~my-course-my-course-m~a1b04165",
		"default~course-course-module~listening-listening-module~my-course-my-course-module~online-test-tests~9d2660cc",
		"online-test-tests-tests-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;